"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconButton = exports.balance = exports.inputContainer = exports.error = exports.errorContainer = exports.inputField = exports.amountInput = void 0;

var _react = require("@emotion/react");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  small {\n    font-size: 100%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 3.3em;\n  background: ", ";\n  border-radius: 0.4em;\n  padding: 16px;\n  color: ", ";\n  font-size: 100%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.32);\n  max-width: 308px;\n  z-index: 5;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 15%;\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-bottom-color: ", ";\n    border-top: 0;\n    margin-top: -6px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  color: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  letter-spacing: inherit;\n  caret-color: ", ";\n  max-width: 200px;\n  margin: 0;\n  padding: 0;\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var amountInput = function amountInput(_ref) {
  var colors = _ref.colors,
      fonts = _ref.fonts,
      fontSizes = _ref.fontSizes,
      fontWeights = _ref.fontWeights,
      letterSpacings = _ref.letterSpacings,
      lineHeights = _ref.lineHeights;
  return (0, _react.css)(_templateObject(), fonts.title4, fontSizes.title1, fontWeights.medium, letterSpacings.title1, lineHeights.title1, colors.secondary);
};

exports.amountInput = amountInput;

var inputField = function inputField(_ref2) {
  var colors = _ref2.colors;
  return (0, _react.css)(_templateObject2(), colors.accent);
};

exports.inputField = inputField;
var errorContainer = (0, _react.css)(_templateObject3());
exports.errorContainer = errorContainer;

var error = function error(_ref3) {
  var colors = _ref3.colors;
  return (0, _react.css)(_templateObject4(), colors.accent, colors.white, colors.accent);
};

exports.error = error;
var inputContainer = (0, _react.css)(_templateObject5());
exports.inputContainer = inputContainer;

var balance = function balance(_ref4) {
  var colors = _ref4.colors;
  return (0, _react.css)(_templateObject6(), colors.neutral[500]);
};

exports.balance = balance;

var iconButton = function iconButton(_ref5) {
  var colors = _ref5.colors,
      name = _ref5.name;
  return (0, _react.css)(_templateObject7(), name === 'legacy' ? 'rgba(28, 112, 242, 0.15)' : colors.primary.main);
};

exports.iconButton = iconButton;